import React from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import MemoryTags from './Tags';

interface MemoryCardContentProps {
  title: string;
  content: string;
  tags: number[];
};

const MemoryCardContent: React.FC<MemoryCardContentProps> = ({ title, content, tags, }) => {
  return (
    <div className="memory-card-content">
      <h5>
        {title === '<placeholder>' ? <Skeleton /> : title}
      </h5>
      <p>
        {content === '<placeholder>' ? <Skeleton count={3} /> : content}
      </p>
      <MemoryTags tags={tags} readOnly />
    </div>
  );
}

export default MemoryCardContent;
